import React, { useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import Dropdown from '../FieldsComponents/Dropdown';
import axios from 'axios';

const ClothStkReport = () => {
    const [formData, setFormData] = useState({
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
        profit: '',
        loss: ''
    });
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const [stockdata, setStockdata] = useState([]);
    const [inward, setInward] = useState([]);
    const [outward, setOutward] = useState([]);
    const [clothlist, setClothlist] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        fetchClothstklist()
    }, []);

    const fetchClothstklist = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=cloth_stk_overall_reports`);
            setClothlist(res.data?.cloth_list);
        } catch (error) {
            console.log(error);
        }
    };

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };


    const fetchCloth_stkdata = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=cloth_stk_overall_reports&clothId=${id}`);
            console.log(res);
            const current_stk = res?.data?.stk_data;
            const inward_stk = res.data?.inward_data;
            const outward_stk = res.data?.outward_data;
            setStockdata(current_stk);
            setOutward(outward_stk);
            setInward(inward_stk);
        } catch (error) {
            console.log(error);
        }
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        if (dropdownType === "clothId") {
            fetchCloth_stkdata(value);
        }else{
            setStockdata([]);
            setInward([]);
            setOutward([]);
        }
    };
    const dropdownlistDepartment = [
        {
            label: 'Cloth',
            id: 'clothId',
            options: clothlist || [],
            value: formData.clothId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId'),
            getOptionLabel: (option) => option.clothNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper style={{ padding: '3vh', margin: '0' }}>
                        <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                            <h3 className='centered-heading'>Cloth Stock Report View</h3>
                            <div className="dashed-line"></div>

                            {
                                dropdownlistDepartment && dropdownlistDepartment?.map((drop) => (
                                    <Dropdown
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}
                                    />
                                ))
                            }

                            <h4>Current Stock</h4>

                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableHead>
                                        <TableRow className='tbl-row'>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth ID</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Actual Mtr.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bal Mtr.</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {stockdata?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.clothNm}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.clothId}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.actmtr}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.mtr}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <h4>Inward Stock</h4>
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableHead>
                                        <TableRow className='tbl-row'>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Date</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Inward Mtr.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bal Mtr.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Lump Actual Mtr.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Lump Mtr.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Barcode</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* <TableRow>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' colSpan={2}>Total</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {inward.reduce((acc, sum) => acc + Number(sum.mtr), 0)}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {inward.reduce((acc, sum) => acc + Number(sum.bmtr), 0)}
                                            </TableCell>
                                        </TableRow> */}
                                        {inward?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.dt2}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.bale}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.mtr}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.bmtr}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.lump_mtr}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.lump_bmtr}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.barcodes}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' colSpan={2}>Total</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {inward.reduce((acc, sum) => acc + Number(sum.mtr), 0)}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {inward.reduce((acc, sum) => acc + Number(sum.bmtr), 0)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>


                            <h4>Outward Stock</h4>
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableHead>
                                        <TableRow className='tbl-row'>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Date</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SO No.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Challan No.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Employee</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Item</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Outward Mtr.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bal Mtr.</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* <TableRow>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' colSpan={2}>Total</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {outward.reduce((acc, sum) => acc + Number(sum.mtr), 0)}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {outward.reduce((acc, sum) => acc + Number(sum.bmtr), 0)}
                                            </TableCell>
                                        </TableRow> */}
                                        {outward?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.dt2}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.sono}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.challanId}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.empNm}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.itemNm}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.baleNo}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.baleMtr}</TableCell>
                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.gMtr}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' colSpan={6}>Total</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {outward.reduce((acc, sum) => acc + Number(sum.baleMtr), 0)}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {outward.reduce((acc, sum) => acc + Number(sum.gMtr), 0)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                            <ReactToPrint
                                trigger={() => <Button variant="contained" color="primary">Print</Button>}
                                content={() => componentRef.current}
                            />
                        </div>
                    </Paper>
                </Grid>

            </Grid>
        </>
    );
};

export default ClothStkReport;
